<div class="comm-layout-container h-100">
    <app-sc-template-form
        [singlePropertyInputModel]="singlePropertyInput"
        [multiplePropertyInputModel]="multiplePropertyInput"
        [viewMode]="viewMode"
    ></app-sc-template-form>
    <app-sc-template-view [viewMode]="viewMode"></app-sc-template-view>
</div>
